"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImageComplete = exports.uploadImage = exports.updateCurrentStep = exports.submitClaim = exports.registerClaimInfo = exports.getLocationData = exports.clearClaimInfo = void 0;
var t = _interopRequireWildcard(require("./types"));
var _environment = _interopRequireDefault(require("../../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var submitClaimUrl = _environment.default.CLAIMS.claimUrl;
var submitImageUrl = _environment.default.CLAIMS.imageUrl;
var locationDetailsUrl = _environment.default.GOOGLE_API.mapGeocodeUrl;
var updateCurrentStep = exports.updateCurrentStep = function updateCurrentStep(currentStep) {
  return {
    type: t.UPDATE_STEP,
    payload: currentStep
  };
};
var uploadImageComplete = exports.uploadImageComplete = function uploadImageComplete(result) {
  return {
    type: t.UPLOAD_IMAGE_SUCCESS,
    payload: result
  };
};
var registerClaimInfo = exports.registerClaimInfo = function registerClaimInfo(claimInfo) {
  return {
    type: t.REGISTER_CLAIM_INFO,
    payload: claimInfo
  };
};
var clearClaimInfo = exports.clearClaimInfo = function clearClaimInfo() {
  return {
    type: t.CLEAR_CLAIM_INFO,
    payload: {}
  };
};
var submitClaim = exports.submitClaim = function submitClaim(claim, policyNumber) {
  return {
    type: t.SUBMIT_CLAIM_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: submitClaimUrl + '/' + policyNumber + '/claim',
      body: claim
    }
  };
};
var uploadImage = exports.uploadImage = function uploadImage(imageData) {
  return {
    type: t.SUBMIT_IMAGE_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: submitImageUrl,
      body: imageData
    }
  };
};
var getLocationData = exports.getLocationData = function getLocationData(lat, long) {
  return {
    type: t.LOCATION_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: locationDetailsUrl + lat + ',' + long
    }
  };
};